export var DelimiterType;
(function (DelimiterType) {
    DelimiterType["colon"] = ":";
    DelimiterType["comma"] = ",";
    DelimiterType["equalSign"] = "=";
    DelimiterType["pipe"] = "|";
    DelimiterType["semicolon"] = ";";
    DelimiterType["space"] = " ";
    DelimiterType["tab"] = "\t";
    DelimiterType["doubleColon"] = "::";
    DelimiterType["doublePipe"] = "||";
    DelimiterType["doubleSemicolon"] = ";;";
})(DelimiterType || (DelimiterType = {}));
//# sourceMappingURL=delimiterType.enum.js.map